import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import { useRouter } from "next/router";

export const defaultValue = {
  isMapPage: false,
  isDailyRentPage: false,
  isRedMode: false,
  msgsCount: 0,
  chartJSLoaded: false,
  isMobile: false,
};

/* eslint-disable */

export const AppContext = createContext(defaultValue);

export function AppContextProvider({ value, children } = {}) {
  const [state, setValue] = useState(value || defaultValue);
  const router = useRouter();

  const updateContext = useCallback(
    (value) => {
      setValue({ ...state, ...value });
    },
    [state, router],
  );
  useEffect(() => {
    setValue((currentState) => ({
      ...{},
      ...currentState,
      ...(value || {}),
    }));
  }, [value]);

  return (
    <AppContext.Provider value={{ ...state, updateContext }}>
      {children}
    </AppContext.Provider>
  );
}
export function useAppState(select) {
  if (!select) return useContext(AppContext);
  return useContext(AppContext)[select];
}
export default AppContextProvider;
